import React, { useState, useEffect, useMemo } from 'react';
import { FormControl, InputLabel, MenuItem, Select, makeStyles } from '@material-ui/core';
import { wsGet, wsFindBy, wsPost, wsRemove, wsUpdate } from 'services/WService';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import GridContainer from 'components/Grid/GridContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import Button from 'components/CustomButtons/Button';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Add, Delete } from '@material-ui/icons';
import GridItem from 'components/Grid/GridItem';
import { useParams } from 'react-router-dom';
import styles from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js';
// import stylesForm from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'item_code' },
  { Header: 'Descripción', accessor: 'item_description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const columns2 = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'item_code', width: 150 },
  { Header: 'Descripción', accessor: 'item_description' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const useStyles = makeStyles(() => ({
  ...styles,
}));

function PortfolioDetail(props) {
  const classes = useStyles();
  const { id } = useParams();

  const [portfolio, setPortfolio] = useState({});
  const [details, setDetails] = useState([]);
  const [items, setItems] = useState([]);
  const [alert, setAlert] = useState(null);

  const typeDescription = useMemo(() => {
    switch (portfolio.item_type) {
      case 'C':
        return 'Categorías';
      case 'L':
        return 'Líneas';
      case 'F':
        return 'Familias';
      case 'P':
        return 'Productos';
      default:
        return null;
    }
  }, [portfolio.item_type]);

  async function addDetail(itemId) {
    await wsPost(`logi/portfolio/${portfolio.id}/detail`, {
      item_id: itemId,
      excluded: portfolio.item_type === 'P' ? 'Y' : 'N',
    });
    loadPortfolio();
  }

  async function deleteDetail(itemId) {
    await wsRemove(`logi/portfolio/${portfolio.id}/detail`, itemId);
    loadPortfolio();
  }

  function loadPortfolio() {
    wsGet('logi/portfolio', id).then((res) => {
      let { details, ...data } = res.data;
      setPortfolio(data);
      setDetails(details);
    });
  }

  function saveDetailType(e) {
    let detail_type = e.target.value;
    setPortfolio((port) => ({ ...port, detail_type }));
    wsUpdate('logi/portfolio', portfolio.id, {
      detail_type,
    });
  }

  function saveItemType(e) {
    let item_type = e.target.value;
    setAlert(
      <SweetAlert
        warning
        style={{ display: 'block', marginTop: '-100px' }}
        title="Cambio de tipo detalles"
        onConfirm={async () => {

          let res = await wsUpdate('logi/portfolio', portfolio.id, {
            item_type,
          });
          if(res.success){
            setPortfolio((port) => ({ ...port, item_type }));
            setDetails([]);
            // loadItems();
            setAlert(null);
          }
        }}
        onCancel={() => setAlert(null)}
        confirmBtnCssClass={classes.button + ' ' + classes.success}
        cancelBtnCssClass={classes.button + ' ' + classes.danger}
        confirmBtnText="Aceptar"
        cancelBtnText="Cancelar"
        showCancel
      >
        ¡Esto eliminara todos los detalles!
      </SweetAlert>,
    );
  }

  useEffect(() => {
    loadPortfolio();
  }, []);

  useEffect(() => {
    loadItems();
  }, [portfolio.item_type]);

  async function loadItems() {
    if (portfolio.id === undefined) return;
    let search = {};
    for (let filterKey of [
      'base_business_partner_id',
      'logi_mark_id',
      'logi_category_id',
      'logi_line_id',
      'logi_family_id',
    ]) {
      if (portfolio[filterKey] !== null) {
        search[filterKey] = portfolio[filterKey];
      }
    }
    let res = null;
    switch (portfolio.item_type) {
      case 'C':
        res = await wsFindBy('logi/category', search);
        setItems(
          res.data.map((item) => ({
            id: item.id,
            item_id: item.id,
            item_code: item.code,
            item_description: item.description,
          })),
        );
        break;
      case 'L':
        res = await wsFindBy('logi/line', search);
        setItems(
          res.data.map((item) => ({
            id: item.id,
            item_id: item.id,
            item_code: item.code,
            item_description: item.description,
          })),
        );
        break;
      case 'F':
        res = await wsFindBy('logi/family', search);
        setItems(
          res.data.map((item) => ({
            id: item.id,
            item_id: item.id,
            item_code: item.code,
            item_description: item.description,
          })),
        );
        break;
      case 'P':
        res = await wsFindBy('logi/product', search);
        setItems(
          res.data.map((item) => ({
            id: item.id,
            item_id: item.id,
            item_code: item.ItemCode,
            item_description: item.ItemName,
          })),
        );
        break;
    }
  }

  return (
    <CardContainer title={'Detalle de portafolio'}>
      {alert}
      {/* Cabecera */}
      <GridItem xs={12}>
        <GridContainer>
          <GridItem xs={1}>
            <h6>id</h6>
            <h5>{portfolio.id}</h5>
          </GridItem>
          <GridItem xs={3}>
            <h6>Mesa</h6>
            <h5>
              ({portfolio.base_bureau_code}){portfolio.base_bureau_description}
            </h5>
          </GridItem>
          <GridItem xs={3}>
            <h6>Marca</h6>
            <h5>
              ({portfolio.logi_mark_code}) {portfolio.logi_mark_description}
            </h5>
          </GridItem>
          <GridItem xs={5}>
            <h6>Proveedor</h6>
            <h5>
              ({portfolio.CardCode}) {portfolio.CardName}
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={4}>
            <h6>Categoría</h6>
            <h5>{portfolio.logi_category_description ?? 'No establecido'}</h5>
          </GridItem>
          <GridItem xs={4}>
            <h6>Línea</h6>
            <h5>{portfolio.logi_line_description ?? 'No establecido'}</h5>
          </GridItem>
          <GridItem xs={4}>
            <h6>Familia</h6>
            <h5>{portfolio.logi_family_description ?? 'No establecido'}</h5>
          </GridItem>

          {/* detail_type */}
          <GridItem xs={6}>
            {/* <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Funcionalidad de detalle</InputLabel>
              <Select
                value={portfolio.detail_type || 'E'}
                inputProps={{ name: 'detail_type' }}
                onChange={saveDetailType}
              >
                <MenuItem value="E">Excluir</MenuItem>
                <MenuItem value="I">Incluir</MenuItem>
              </Select>
            </FormControl> */}
            <h6>Funcionalidad de detalle</h6>
            <h5>{portfolio.detail_type == 'E' ? 'Excluir' : 'Incluir'}</h5>
          </GridItem>

          {/* item_type */}
          <GridItem xs={6}>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo detalle</InputLabel>
              <Select value={portfolio.item_type || 'P'} onChange={saveItemType}>
                <MenuItem value="C">Categoría</MenuItem>
                <MenuItem value="L">Línea</MenuItem>
                <MenuItem value="F">Família</MenuItem>
                <MenuItem value="P">Producto</MenuItem>
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
      </GridItem>
      {/* Tablas */}
      <GridItem xs={12}>
        <h3>
          {typeDescription === null
            ? 'Cargando...'
            : `${typeDescription} ${portfolio.detail_type === 'E' ? 'excluidos' : 'incluidos'}`}
        </h3>
        <ReactTable
          columns={columns}
          data={details.map((item, index) => {
            return {
              num: (
                <div className="actions-right">
                  {index + 1}
                  <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    onClick={() => deleteDetail(item.item_id)}
                  >
                    <Delete />
                  </Button>
                </div>
              ),
              ...item,
            };
          })}
        />
      </GridItem>
      <GridItem xs={12}>
      <h3>
          {typeDescription === null
            ? 'Cargando...'
            : `${typeDescription} a ${portfolio.detail_type === 'E' ? 'excluir' : 'incluir'}`}
        </h3>
        <ReactTable
          columns={columns2}
          data={items
            .filter((item) => {
              let index = details.findIndex((detail) => detail.item_id == item.id);
              if (index !== -1) return false;
              return true;
            })
            .map((item, index) => {
              return {
                num: (
                  <div className="actions-right">
                    {index + 1}
                    <Button
                      justIcon
                      round
                      simple
                      color="success"
                      onClick={() => {console.log(item);addDetail(item.id)}}
                    >
                      <Add />
                    </Button>
                  </div>
                ),
                ...item,
              };
            })}
        />
      </GridItem>
    </CardContainer>
  );
}

export default PortfolioDetail;
